import { connect } from 'react-redux'
import { forwardRef, useState } from 'react'
import { Button } from 'antd'
import Feather from '@sysunite/react-feather'
import { NodePicker, withBounds } from 'Components'
import { setGraphShowingNode } from 'Actions/graph'
import { loadGraphData } from 'Services/GraphUtils'
import { updateGraphNodes } from 'Actions/graph'

const GraphShowingNodePopover = forwardRef(({
  setGraphShowingNode,
  updateGraphNodes,
  style
}, ref) => {

  const [nodes, setNodes] = useState(undefined)

  const getId = (uid) => uid.split('@')[0]

  const addToGraph = async () => {
    updateGraphNodes(
      await loadGraphData(
        new Weaver.Query().restrict(
          nodes.map(getId)
        ).selectOut('*')
        .selectIn('*')
      )
    )
  }

  <div
    ref={ref}
    style={{
      ...style,
      boxShadow: 'rgba(0,0,0,0.06) 0px 4px 12px 0px',
      borderRadius: '9px',
      padding: '16px',
      zIndex: 2,
      position: 'fixed',
      width: 400
    }}
  >
    <Button
      type="link"
      onClick={() => setGraphShowingNode(undefined) }
      style={{ padding: 0, paddingRight: 16 }}
    >
      <Feather type="x" />
    </Button>
    <NodePicker
      style={{ width: '75%', paddingRight: 8 }}
      mode="multiple"
      onSelect={(vals) => setNodes(vals)}
    />
    <Button
      disabled={!nodes}
      type="primary"
      onClick={() => {
        addToGraph()
        setNodes(undefined)
        setGraphShowingNode(undefined)
      }}
    >
      Ok
    </Button>
  </div>
})

const mapStateToProps = ({ graph: { isShowingNode, graphData } }) => { isShowingNode, graphData }

export default connect(mapStateToProps, { setGraphShowingNode, updateGraphNodes })(
  withBounds(GraphShowingNodePopover)
)
